import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getScheduleUpdatedBySelector } from '../../../redux/slices/ganttSlice.js';
import { Colors } from '../../../constants/colors.constants.js';
import { WarningRedIcon } from '../../../icons/index.js';
import MemberAvatar from '../../CollaborativeSpaceMembers/MemberAvatar/MemberAvatar.tsx';
import './GanttOutdatedTooltip.scss';
import { type Member } from '../../../assets/js/collaborative_space';

interface GanttOutdatedTooltipProps {
  scheduleUpdatedBy: {
    member: Member | null;
    updatedAt: Date | null;
  };
}
const GanttOutdatedTooltip = ({
  scheduleUpdatedBy
}: GanttOutdatedTooltipProps) => {
  const { t } = useTranslation();
  const { member, updatedAt } = scheduleUpdatedBy;

  if (!member) {
    return null;
  }

  return (
    <div className="gantt-outdated-tooltip">
      <WarningRedIcon
        color={Colors.RED}
        className="gantt-outdated-tooltip__icon"
      />
      <div className="gantt-outdated-tooltip__content">
        <div className="gantt-outdated-tooltip__title">
          {t('master_plan.schedule_out_of_date_title')}
        </div>
        <div className="gantt-outdated-tooltip__description">
          {t('master_plan.schedule_out_of_date_description')}
        </div>
        <div className="gantt-outdated-tooltip__member">
          <div className="gantt-outdated-tooltip__description">
            {t('master_plan.schedule_out_of_date_by')}
          </div>
          <div className="gantt-outdated-tooltip__member-info">
            <div className="gantt-outdated-tooltip__member-avatar">
              <MemberAvatar member={member} size={32} />
            </div>
            <div className="gantt-outdated-tooltip__member-info-text">
              {member.profileData.fullName}
              <div className="gantt-outdated-tooltip__timestamp">
                {moment(updatedAt).calendar()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  scheduleUpdatedBy: getScheduleUpdatedBySelector(state)
});

export default connect(mapStateToProps)(GanttOutdatedTooltip);
